export const rangeNames = { today: "今日", last7: "近7天", last30: "近30天", month: "本月", year: "本年", all: "全部" };
export const typeNames = { number: "数字卡片", line: "折线图", bar: "柱状图", horizontalBar: "横向柱状图", list: "列表" };
export function statisticChartOption(widget, rows) {
	const horizontal = widget.displayType === 'horizontalBar';
	const category = { type: 'category', data: rows.map(x => x.label || x.date), ...(horizontal ? { inverse: true } : {}) };
	const value = { type: 'value', minInterval: widget.decimals ? 0 : 1 };
	return {
		color: [widget.color], tooltip: { trigger: 'axis', confine: true },
		grid: { left: 12, right: horizontal && rows.length > 8 ? 42 : 20, top: 18, bottom: 12, containLabel: true },
		xAxis: horizontal ? value : category, yAxis: horizontal ? category : value,
		dataZoom: horizontal && rows.length > 8 ? [{ type: 'slider', yAxisIndex: 0, right: 0, width: 14, startValue: 0, endValue: 7, filterMode: 'filter' }] : [],
		series: [{ name: widget.unit || '数量', type: ['bar', 'horizontalBar'].includes(widget.displayType) ? 'bar' : 'line', data: rows.map(x => x.count), barMaxWidth: 28, smooth: true, areaStyle: widget.displayType === 'line' ? { opacity: 0.08 } : undefined }]
	};
}
export function layoutError(items) {
	if (!Array.isArray(items) || items.length > 50) return "每个模板最多50个组件";
	const occupied = new Set();
	for (const p of items) {
		if (p.groupKey && (!p.title || !p.title.trim() || !p.children || !p.children.length)) return "请填写统计块标题并至少选择一个数字指标";
		if (p.groupKey && new Set(p.children.map(c => c.widgetKeyId)).size !== p.children.length) return "统计块内不能重复选择数字指标";
		if (![p.row, p.col, p.width, p.height].every(Number.isInteger) || p.row < 1 || p.row > 100 || p.col < 1 || p.width < 1 || p.col + p.width > 13 || p.height < 100 || p.height > 600)
			return "组件位置或尺寸超出允许范围";
		for (let c = p.col; c < p.col + p.width; c++) {
			const cell = `${p.row}:${c}`;
			if (occupied.has(cell)) return "组件位置重叠，请调整行、列或宽度";
			occupied.add(cell);
		}
	}
	if (items.reduce((n, p) => n + (p.groupKey ? p.children.length : 1), 0) > 50) return "每个模板最多50个统计指标";
	return "";
}
// Keep each metric as a separately authorized backend item, sharing only the block layout.
export function flattenLayout(items) {
	return items.flatMap(p => p.groupKey ? p.children.map((c, groupOrder) => ({ ...c, groupKey: p.groupKey, groupTitle: p.title, groupOrder, row: p.row, col: p.col, width: p.width, height: p.height })) : [{ ...p }]);
}
export function groupHomeItems(items) {
	const result = [], groups = new Map();
	for (const item of items) {
		if (item.children) { result.push(item); continue; }
		const key = item.placement.groupKey;
		if (!key) { result.push(item); continue; }
		if (!groups.has(key)) {
			const block = { keyId: 'group:' + key, placement: { ...item.placement, title: item.placement.groupTitle }, widget: { name: item.placement.groupTitle, displayType: 'group' }, children: [] };
			groups.set(key, block); result.push(block);
		}
		groups.get(key).children.push(item);
	}
	for (const item of result) if (item.children) item.children.sort((a, b) => (a.placement.groupOrder || 0) - (b.placement.groupOrder || 0));
	return result;
}
export function editorLayout(items) {
	return groupHomeItems(items).map(item => item.children ? { ...item.placement, children: item.children.map(c => ({ ...c.placement })) } : { ...item.placement });
}
export function nextPosition(items, width) {
	for (let row = 1; row <= 100; row++)
		for (let col = 1; col <= 13 - width; col++) {
			if (!layoutError([...items, { row, col, width, height: 140 }])) return { row, col };
		}
	return null;
}
export function statisticTable(value, widget) {
 if (value && !Array.isArray(value) && Array.isArray(value.columns) && Array.isArray(value.rows)) return value;
 return { columns: [{key:'label',label:widget.dimension || '日期'}, {key:'count',label:widget.unit === '元' ? '金额（元）' : widget.unit === '%' ? '比例（%）' : '数量' + (widget.unit ? '（' + widget.unit + '）' : '')}], rows: (Array.isArray(value) ? value : []).map(x => ({label:x.label || x.date, count:x.count})) };
}
export const scopeNames = { authorized: '授权门店', store: '当前门店', self: '本人' };
export function exampleValue(widget) {
 if (widget.metric && /^(staff|reception)/.test(widget.metric) && widget.displayType !== 'number') {
  if (widget.displayType === 'list' && /List$|\.detail$|staffSalary\.rank$/.test(widget.metric)) return {columns:[{key:'name',label:'人员'},{key:'detail',label:'统计内容'}],rows:[{name:'示例员工甲',detail:'示例记录'},{name:'示例员工乙',detail:'示例记录'}]};
  return ['示例员工甲','示例员工乙','示例员工丙','示例员工丁'].map((label,i)=>({label: widget.dimension === '月份' ? '2026-'+String(i+1).padStart(2,'0') : widget.dimension === '日期' ? '10-'+String(i+1).padStart(2,'0') : label,count:widget.unit === '元' ? [8250,6430,5260,3980][i] : [36,28,24,18][i]}));
 }

	return widget.displayType === "number"
		? widget.unit === "元"
			? 86520
			: 128
		: Array.from({ length: 14 }, (_, i) => ({ date: `10-${String(i + 1).padStart(2, "0")}`, count: [16, 28, 24, 46, 38, 65, 57, 72, 63, 96, 82, 74, 92, 110][i] }));
}
